module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.accountDetails) ? _c('div', {
    staticClass: "row d-flex flex-column pl-3 pb-4",
    class: {
      'opacity-50': _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "pt-3 pb-4 fs-large"
  }, [_c('div', {
    staticClass: "col-12 d-flex flex-column pl-0"
  }, [_c('div', {
    staticClass: "fs-larger bold pb-1"
  }, [_vm._v(_vm._s(((_vm.accountDetails.title) + " ")) + " "), _c('b', {
    staticClass: "dark fs-largest font-weight-700"
  }, [_vm._v(_vm._s(("(" + (_vm.accountDetails.date) + ")")))]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "account-card-sub-title bold"
  }, [_vm._v(_vm._s(("" + (_vm.accountDetails.subTitle))))])])]), _vm._v(" "), (_vm.accountDetailsValidation) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.accountDetails.info), function(info) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12 pb-3"
    }, [_c('div', {
      staticClass: "card d-flex"
    }, [_c('div', {
      staticClass: "d-flex flex-grow-1 flex-column justify-content-between"
    }, [_c('div', {
      staticClass: "fs-large bold"
    }, [_vm._v(_vm._s(((info.title) + ":")))]), _vm._v(" "), (info.valueType === 'number') ? _c('span', {
      staticClass: "bold dark values"
    }, [_vm._v(_vm._s(("" + (info.value))))]) : (info.valueType === 'cash') ? _c('span', {
      staticClass: "bold dark values"
    }, [_vm._v(_vm._s(((_vm.formatPriceWithSpaces(info.value)) + " €")))]) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "fs-largest fas fa-info-circle dark pt-1"
    })])])
  }), 0) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 pb-3",
    class: {
      'opacity-50': _vm.isLoading
    }
  }, [_vm._m(0)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-center card no-info"
  }, [_c('div', {
    staticClass: "d-flex flex-grow-1 flex-row justify-content-between align-items-center"
  }, [_c('span', {
    staticClass: "fs-large bold"
  }, [_vm._v("No information available!")]), _vm._v(" "), _c('i', {
    staticClass: "fs-largest fas fa-exclamation-circle dark"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f625f9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/myPlan/AccountDetails.vue
// module id = 2271
// module chunks = 0